import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ModalController, AlertController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
import { DomSanitizer } from '@angular/platform-browser';

import { LoginPage } from '../login/login';

// import * as $ from "jquery";

/**
 * Generated class for the QnaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-qna',
	templateUrl: 'qna.html',
})
export class QnaPage {

	items: any;	
	answer: any;
	loginId: string;
	api_key: string;
	version: string;
	idx: string;

	photo_count: number = 0;
	photo_on: boolean = false;

	texts: any = [];
	language: string;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
		public viewCtrl: ViewController,
        private http: HttpService,
		public app: App,
		private sanitizer: DomSanitizer
	) {
		this.idx = navParams.get('idx');
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
        if(!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "qna");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		
		this._init();

		// this._init().then(res => {
		// 	setTimeout(() => {
		// 		this._js();
		// 	}, 250);
		// });
		
		this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).qna;
	}

	_init() {
		return new Promise((resolve,reject)=>{
			
			let url = "info/qa/index/detail";
			let body = JSON.stringify({ 
				api: this.api_key,
				language: this.language,
				version: this.version,
				idx: this.idx
			});
			this.http.post(url, body).then((res: any) => {
				if(res.result=="OK"){
					if(res.list == undefined) {
						
						return;
					}else {
						this.items = res.list;
						this.answer = this.sanitizer.bypassSecurityTrustHtml(res.list.answer);
						resolve(this.items);
						
					}
				} else if(res.result ==="LOGOUT"){
					
					let alert = this.alertCtrl.create({
						message: res.message,
						buttons: ['OK']
					});
					alert.present();
					localStorage.removeItem("loginId");
					localStorage.removeItem("api_key");
					this.app.getRootNav().setRoot(LoginPage);
				
				} else {
					
					let alert = this.alertCtrl.create({
						message: res.message,
						buttons: ['OK']
					});
					alert.present();
				}
			
			},(err)=>{
				reject(err);
				
				let alert = this.alertCtrl.create({
					message: this.texts.alertM_err,
					buttons: ['OK']
				});
				alert.present();
			});
		});
	}

	// _js() {
	// 	let question_H = $('.question').height();

	// 	if (question_H >= 150) {
	// 		$('.question').css({'max-height': '150px'});
	// 		$('.close').hide(0);

	// 		$('.open').click(function(){
	// 			$('.question').css({'max-height': question_H + 50});
	// 			$('.close').show(0);
	// 			$(this).hide(0);
	// 		});
	// 		$('.close').click(function(){
	// 			$('.question').css('max-height','150px');
	// 			$('.open').show(0);
	// 			$(this).hide(0);
	// 		});
	// 	} else {
	// 		$('.close').hide(0);
	// 		$('.open').hide(0);
	// 	}
	// }
}



// WEBPACK FOOTER //
// ./src/pages/qna/qna.ts